/**
 * Tabbed Product Feed - Show/hide product lists based on tab heading clicks.
 * Uses data-tab-trigger (on headings) and data-tab-name (on panels) for matching.
 */
import { ThemeBus } from './events-bus.js';
import { EVENTS } from './event-constants.js';

class TabbedProductFeed {
  constructor() {
    this.section = document.querySelector('[data-tabbed-product-feed]');
    if (!this.section) return;

    this.tabButtons = this.section.querySelectorAll('.tabbed-product-feed__tab-button');
    this.tabPanels = this.section.querySelectorAll('.tabbed-product-feed__panel');
    this.tabLinks = this.section.querySelectorAll('.tabbed-product-feed__tab-link');

    if (this.tabButtons.length === 0 || this.tabPanels.length === 0) return;

    this.init();
  }

  init() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', (e) => this.handleTabClick(e));
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.handleTabClick(e);
        }
      });
    });

    // Set initial active state - first panel by DOM order (fallback if Liquid hid all)
    const firstPanel = this.section.querySelector('.tabbed-product-feed__panel:not(.hidden)')
      ?? this.tabPanels[0];
    const initialTab = firstPanel?.dataset.tabName;
    if (initialTab) {
      this.switchTab(initialTab);
    }
  }

  handleTabClick(e) {
    const button = e.currentTarget;
    const tabName = button.dataset.tabTrigger;
    if (!tabName) return;

    this.switchTab(tabName);
    ThemeBus.dispatchEvent(new Event(EVENTS.gridUpdated));
  }

  switchTab(tabName) {
    // Update tab buttons
    this.tabButtons.forEach((btn) => {
      const isActive = btn.dataset.tabTrigger === tabName;
      btn.setAttribute('aria-selected', isActive);
      btn.classList.toggle('border-black', isActive);
      btn.classList.toggle('text-black', isActive);
      btn.classList.toggle('border-transparent', !isActive);
      btn.classList.toggle('text-ink-secondary', !isActive);
      btn.classList.toggle('hover:text-ink-primary', !isActive);
    });

    // Show/hide panels
    this.tabPanels.forEach((panel) => {
      const isActive = panel.dataset.tabName === tabName;
      panel.classList.toggle('hidden', !isActive);
    });

    // Show/hide tab links (View all buttons)
    this.tabLinks.forEach((link) => {
      const isActive = link.dataset.tabName === tabName;
      link.classList.toggle('hidden', !isActive);
    });
  }
}

function init() {
  new TabbedProductFeed();
}

init();
